import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'

const BankAccountUI = ({ context, loan, onRefreshClick, bankAccountList,}) =>
  <div className='su_l_bank'>
    <CardUI title='Loan Balances'>
      <div>
        <div className='g_flex_h g_flex_top'>
          <div>
            <div className='g_m_bottom_100'>Outstanding Loan:
              <span className='g_m_left_100'><b>{loan.outstandingBalanceF1}</b></span>
            </div>
            <table><tbody>
              <tr><td></td>
                <th className='g_p_left_100'>Total Paid</th>
                <th className='g_p_left_100'>Remaining</th><th>Last Paid</th>
                <th className='g_p_left_100'>Overdue</th>
              </tr>
              <tr><td><b>Principal</b></td>
                <td className='g_text_right g_p_left_100'>{loan.principalPaidF1}</td>
                <td className='g_text_right g_p_left_100'>{loan.principalLeftF1}</td>
                <td className='g_text_right g_p_left_100'>{loan.principalLastPaidF1}</td>
                <td className='g_text_right g_p_left_100'>{loan.principalOverdueF1}</td>
              </tr>
              <tr><td><b>Interest</b></td>
                <td className='g_text_right g_p_left_100'>{loan.interestPaidF1}</td>
                <td className='g_text_right g_p_left_100'>{loan.interestLeftF1}</td>
                <td className='g_text_right g_p_left_100'>{loan.interestLastPaidF1}</td>
                <td className='g_text_right g_p_left_100'>{loan.interestOverdueF1}</td>
              </tr>
              <tr><td><b>Tax</b></td>
                <td className='g_text_right g_p_left_100'>{loan.taxPaidF1}</td>
                <td className='g_text_right g_p_left_100'>{loan.taxLeftF1}</td>
                <td className='g_text_right g_p_left_100'>{loan.taxLastPaidF1}</td>
                <td className='g_text_right g_p_left_100'>{loan.taxOverdueF1}</td>
              </tr>
              <br />
              {/* <tr className='g_muted g_small '><td><b>Outstanding Loan Formula: </b></td>
              <td className='g_text_right g_p_left_100'>{loan.outstandingBalanceFormula}</td>
            </tr> */}
            </tbody></table>
          </div>

          <table><tbody>
            <tr><td>Days Past Due:</td><td className='g_text_right'>{loan.daysPastDue}</td></tr>
            <tr><td>DSRA Interest Paid:</td><td className='g_text_right'>{loan.dsraDipIntPaidF1}</td></tr>
            <tr><td>DSRA Interest Overdue:</td><td className='g_text_right'>{loan.dsraDipIntOverdueF1}</td></tr>
            <tr><td>Penal Charge Paid:</td><td className='g_text_right'>{loan.defaultIntPaidF1}</td></tr>
            <tr><td>Penal Charge Overdue:</td><td className='g_text_right'>{loan.defaultIntOverdueF1}</td></tr>
          </tbody></table>
        </div>
        <span className='g_small'><b>Outstanding Loan Calculation: </b> {loan.outstandingBalanceFormula}</span>
      </div>

    </CardUI>

    <CardUI title='Account Balances' className='g_m_top_100'>
      <table className='g_m_top_50'>
        <tbody>
          <tr className='g_muted g_small'>
            <td align='center'>Escrow account balance</td><td></td>
            <td align='center'>Current month payable</td><td></td>
            <td align='center'>Total DSRA</td><td></td>
            <td align='center'>Current DRSA</td><td></td>
          </tr>
          <tr >
            <td align='right'>{loan.account.virtualAccountBalanceF1}</td><td></td>
            <td align='right'>{loan.account.currentPayableF1}</td><td></td>
            <td align='right'>{loan.account.totalDsraF1}</td><td></td>
            <td align='right'>{loan.account.currentDsraF1}</td><td></td>
          </tr>
        </tbody>
      </table>
      <span className='g_muted g_small'>Updated: </span><span className='g_small'>{loan.account.balanceUpdatedDate}</span>
    </CardUI>

    <CardUI title='Escrow Account Balances' className='g_m_top_100'>
      <table className='g_m_top_50'>
        <tbody>
          <tr className='g_muted g_small'>
            <td align='center'>Escrow A/C no</td><td></td>
            <td align='center'>IFSC</td><td></td>
            <td align='center'>Balance</td><td></td>
            <td align='center'>Pending</td><td></td>
            <td align='center'>Available</td>
          </tr>
          {
            bankAccountList.map((bankAccount, i) =>
              <tr key={i}>
                <td>{bankAccount.bankAccountNumber}</td><td></td>
                <td>{bankAccount.ifscCode}</td><td></td>
                <td align='right'>
                  {bankAccount.currentBalance >= 0 ? bankAccount.currentBalanceF1 : `(${bankAccount.currentBalanceF1})`}
                </td><td></td>
                <td align='right'>
                  {bankAccount.pendingBalance >= 0 ? bankAccount.pendingBalanceF1 : `(${bankAccount.pendingBalanceF1})`}
                </td><td></td>
                <td align='right'>
                  {bankAccount.availableBalance >= 0 ? bankAccount.availableBalanceF1 : `(${bankAccount.availableBalanceF1})`}
                </td>
              </tr>
            )
          }
        </tbody>
      </table>
    </CardUI>
  </div>

export default BankAccountUI
